import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FootprintVersionPreviewComponent } from './footprint-version-preview.component';

@NgModule({
    imports: [CommonModule],
    declarations: [FootprintVersionPreviewComponent],
    exports: [FootprintVersionPreviewComponent],
})
export class FootprintVersionPreviewModule { }
